import React from 'react';
import { connect } from 'react-redux';

//Showing the loader for all Request.
const Loader = ({ requestCount }) => {
  return requestCount ? (
    <div className="global-loader" style={{ display: 'block' }} />
  ) : null;
};

export default connect(state => ({
  requestCount: state.masterData.get('requestCount')
}))(Loader);



// WEBPACK FOOTER //
// ./web/components/common/Loader.js